import {BaseService} from './base'


class DisService extends BaseService {
    constructor() {
        super();
    }
    //获取申请列表
    async queryLaunchList(data){
        const {code,list=[],obj={}} = await this.$http("smarthos.online.remoteoutpatient.apply.list",data);
        return  code == 0 ? {list,obj} : {list:[],obj:{}}
    }

    //取消申请
    async cnacleApply(data){
       return  await this.$http('smarthos.yygh.apiOrderService.cancel',data);
    }

    //签到取号 和 结束问诊
    async getNum(data){
      return  await this.$http('smarthos.yygh.apiOrderService.updateOrderState',data);
    }

    //进入诊间
    async enterRoom(data){
        const {code,obj} = await this.$http('smarthos.online.remoteoutpatient.intovideo',data);
        return code == 0 ? obj : {}
    }
    //获取消息列表
    async getMsgList({outpatientId, pageSize = 1000, pageNum = 1}){
        const {list = [], page = {}} =  await this.$http('smarthos.online.remoteoutpatient.message.page',{
            outpatientId,
            pageNum,
            pageSize
        });
        return {list, page};
    }
    //发送消息
    async reply({outpatientId, msgType = 'TEXT',msgContent}) {
        const {code} = await this.$http('smarthos.online.remoteoutpatient.message.send', {outpatientId, msgType,msgContent});
        return code === '0';
    }
    //查询绑定医生列表
    async getBindDoc(data){
        const {code,list = []} = await this.$http('smarthos.user.book.doc.list', data);
        return code == 0 ? list : [];
    }
    //查询接受列表
    async queryReceiveList(data){
        const {code,list = [],obj={}} = await this.$http('smarthos.online.remoteoutpatient.pack.list', data);
        return code == 0 ? {obj,list} : {list:[],obj:{}};
    }
    //提醒进入房间
    async bellPat(orderId){
        const {code} = await this.$http('smarthos.online.remoteoutpatient.remind.intovideo', {
            outpatientId:orderId
        });
        return code == "0"
    }
    //提醒取号
    async bellGetNum(orderId){
        const {code} = await this.$http('smarthos.online.remoteoutpatient.remind.getnum', {
            outpatientId:orderId
        });
        return code == "0"
    }
    //结束问诊
    async endOrder(orderId){
        const {code} = await this.$http('smarthos.online.remoteoutpatient.complete', {
            outpatientId:orderId
        });
        return code == "0"
    }
    //修改诊疗记录
    async save(data){
        const {code} = await this.$http('smarthos.online.remoteoutpatient.record.update', data);
        return code == "0"
    }
    //上传base64图片
    async loadBase(data){
        return await this.$http('smarthos.system.file.upload.image.base64', data);
    }
    //上传文件
    async loadFile(data){
        return await this.$http('smarthos.system.file.upload', data);
    }
    //查询单号详情
    async queryDetail(data){
        const {code,obj={}} = await  this.$http('smarthos.online.remoteoutpatient.details',data);
        return code == "0"? obj : {};
    }
}

export const disService = new DisService();